import { IconProps } from './types';

export function SystemSettings({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 15 16" {...props}>
      <path
        fill="currentColor"
        d="M6.25 11.544H3.881c-2.375 0-3.1-.725-3.1-3.1v-3.75c0-2.375.725-3.1 3.1-3.1h6.582c2.375 0 3.1.725 3.1 3.1a.472.472 0 0 1-.47.468.472.472 0 0 1-.468-.468c0-1.838-.325-2.163-2.162-2.163H3.88c-1.837 0-2.162.325-2.162 2.163v3.75c0 1.837.325 2.162 2.162 2.162H6.25c.256 0 .469.213.469.469a.472.472 0 0 1-.469.469Z"
      />
      <path
        fill="currentColor"
        d="M6.25 14.37a.472.472 0 0 1-.469-.468V11.07c0-.256.213-.468.469-.468s.469.212.469.468v2.832a.468.468 0 0 1-.469.468ZM6.25 9.047h-5a.472.472 0 0 1-.469-.469c0-.256.213-.469.469-.469h5c.256 0 .469.213.469.47a.472.472 0 0 1-.469.468Z"
      />
      <path
        fill="currentColor"
        d="M6.25 14.375H4.213a.472.472 0 0 1-.469-.469c0-.256.213-.469.469-.469H6.25c.257 0 .47.213.47.47a.472.472 0 0 1-.47.468ZM11.9 14.37H9.68c-1.731 0-2.319-.587-2.319-2.318v-3.57c0-1.73.588-2.318 2.32-2.318H11.9c1.731 0 2.319.588 2.319 2.319v3.569c0 1.737-.588 2.318-2.32 2.318ZM9.68 7.102c-1.225 0-1.381.156-1.381 1.38v3.57c0 1.225.156 1.38 1.381 1.38H11.9c1.225 0 1.381-.155 1.381-1.38v-3.57c0-1.224-.156-1.38-1.381-1.38H9.68Z"
      />
      <path
        fill="currentColor"
        d="M10.813 12.341a.629.629 0 0 1-.444-.18.615.615 0 0 1-.131-.2.678.678 0 0 1-.05-.245.63.63 0 0 1 .18-.437.652.652 0 0 1 .57-.175l.112.037c.037.02.075.038.106.057a.63.63 0 0 1 .281.519.678.678 0 0 1-.05.243.617.617 0 0 1-.13.2.38.38 0 0 1-.1.075.593.593 0 0 1-.107.063.762.762 0 0 1-.113.03c-.043.013-.08.013-.124.013Z"
      />
    </svg>
  );
}
